<template>
  <div class="sort-filter">
    <ListItemFilters
      icon="ui-icon-down-up"
      :title="t(sortLabel, options)"
      :subtitle="t('Сортировка', options)"
      @click="openDialog"
    />

    <v-overlay
      :value="isDialogOpened"
      @click="closeDialog"
    />
    <v-bottom-sheet
      :value="isDialogOpened"
      :width="isMobile ? undefined : 400"
      attach=".vue-the-lpu-filters .v-application"
      content-class="ml-auto rounded-0"
      hide-overlay
      @input="closeDialog"
    >
      <v-card
        tile
        class="py-4"
      >
        <div class="text-h6 px-4 pt-2 mb-2">
          {{ t('Сортировка', options) }}
        </div>
        <v-list>
          <v-list-item
            v-for="(item, i) in sortItems"
            :key="i"
            height="48"
            class="sort-filter__item primary--text"
            @click="handleClick(item.value)"
          >
            <v-list-item-content class="text-body-1 text--text">
              {{ t(item.name, options) }}
            </v-list-item-content>
            <v-list-item-icon v-if="item.value === lpuFiltersState.sort">
              <v-icon
                color="primary"
                class="ma-0"
              >
                ui-icon-check
              </v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import I18NextVue from 'i18next'
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import ListItemFilters from 'www/vue_components/common/TheFilters/common/components/ListItemFilters/ListItemFilters.vue'
import type { Filters } from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore.types'

type SortItem = {
  name: string,
  value: Filters['sort']
}

const emit = defineEmits(['input'])
const props = defineProps<{ value: Filters }>()
const { value: lpuFiltersState } = toRefs(props)

const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('ListItemLpuSort')

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const isMobile = window.MOBILE_VERSION
const sortItems = computed<SortItem[]>(() => [
  { name: 'По рекомендуемым', value: undefined },
  { name: 'По рейтингу', value: 'rating' },
  { name: 'По названию', value: 'name' },
  { name: 'По количеству врачей', value: 'doctors' },
].filter((item): item is SortItem => Boolean(item)))

const sortLabel = computed(() => {
  const currentItem = sortItems.value.find(item => item.value === lpuFiltersState.value.sort)

  return currentItem?.name || sortItems.value[0].name
})

const handleClick = (sort: Filters['sort']) => {
  closeDialog()
  filtersStore.updateUnsavedFilters({ sort })
  emit('input', filtersStore.unsavedFilters)
}
</script>

<style lang="scss" scoped>
.sort-filter {
  &__item {
    min-height: 48px;
    padding: 0 16px;
  }

  &__item :deep(.v-list-item__icon) {
    margin: 12px 0;
  }
}
</style>
